t = require('views/internal/teacup-with-helpers')('list_menu')

module.exports = t.renderable ({ editable, subscribed, canCopyList, canSortByDueDate, canSortByAge, subscribeString }) ->
  t.ul '.pop-over-list', ->
    if editable
      t.li ->
        t.a '.js-add-card', { href: '#' }, ->
          t.format 'add-card-ellipsis'
      if canCopyList
        t.li ->
          t.a '.js-copy-list', { href: '#' }, ->
            t.format 'copy-list-ellipsis'
      t.li ->
        t.a '.js-move-list', { href: '#' }, ->
          t.format 'move-list-ellipsis'
    t.li ->
      t.a '.highlight-icon.js-list-subscribe', { href: '#' }, ->
        # EXPERIMENT: subscribeToWatchOrFollow
        t.check subscribed, subscribeString

  if editable
    t.hr()

    t.ul '.pop-over-list', ->
      t.li ->
        t.a '.js-move-cards', { href: '#' }, ->
          t.format 'move-all-cards-in-this-list-ellipsis'
      t.li ->
        t.a '.js-archive-cards', { href: '#' }, ->
          t.format 'archive-all-cards-in-this-list-ellipsis'

    if canSortByDueDate || canSortByAge
      t.hr()
      t.ul '.pop-over-list', ->
        if canSortByDueDate
          t.li ->
            t.a '.js-sort-by-due-date', { href: '#' }, ->
              t.format 'sort-by-due-date'

        if canSortByAge
          t.li ->
            t.a '.js-sort-newest-first', { href: '#' }, ->
              t.format 'sort-newest-first'

          t.li ->
            t.a '.js-sort-oldest-first', { href: '#' }, ->
              t.format 'sort-oldest-first'

    t.hr()

    t.ul '.pop-over-list', ->
      t.li ->
        t.a '.js-close-list', { href: '#' }, ->
          t.format 'archive-this-list'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/list_menu.coffee